import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowSplitUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconArrowSplitUp"><Path d="M3.75 9.25V3.75M3.75 3.75H9.25M3.75 3.75L12 12M14.75 3.75H20.25M20.25 3.75V9.25M20.25 3.75L12 12M12 12V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconArrowSplitUp;
